// src/utils/clearAppSessionState.js
// Limpa o estado de UI do CRM guardado em sessionStorage (paginação, filtros,
// experimentos vistos, seleção de curva) para que NÃO vaze entre logins/usuários
// na mesma aba — o sessionStorage sobrevive ao redirect do keycloak.logout.
//
// Propositalmente NÃO usa sessionStorage.clear(): isso apagaria também as chaves
// internas do Keycloak (kc-callback-*, kc-*) e poderia atrapalhar o fluxo de auth.
// Só removemos as chaves que o próprio app grava.

const EXACT_KEYS = [
    'viewedExperiments',
    'lastViewedExperimentId',
    'growthSelectedExps',
];

const PREFIXES = ['experimentsPage', 'coletaPage'];

export function clearAppSessionState() {
    try {
        const toRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (!key) continue;
            if (EXACT_KEYS.includes(key) || PREFIXES.some((p) => key.startsWith(p))) {
                toRemove.push(key);
            }
        }
        toRemove.forEach((k) => sessionStorage.removeItem(k));
    } catch (e) {
        // sessionStorage indisponível (modo privado/SSR) — ignora silenciosamente.
    }
}
